import React from 'react';

function Logo({ size = 32 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Shield shape */}
      <path
        d="M24 2L6 10V22C6 34 14 42.5 24 46C34 42.5 42 34 42 22V10L24 2Z"
        fill="url(#shield-grad)"
        stroke="url(#stroke-grad)"
        strokeWidth="1.5"
      />
      {/* Inner shield highlight */}
      <path
        d="M24 5.5L9 12V22C9 32.5 16 39.8 24 43C32 39.8 39 32.5 39 22V12L24 5.5Z"
        fill="url(#inner-grad)"
        opacity="0.6"
      />
      {/* Pokeball line across center */}
      <line x1="10" y1="24" x2="38" y2="24" stroke="white" strokeWidth="1.5" opacity="0.3" />
      <circle cx="24" cy="24" r="4.5" fill="none" stroke="white" strokeWidth="1.5" opacity="0.35" />
      <circle cx="24" cy="24" r="2" fill="white" opacity="0.4" />
      {/* PK text */}
      <text x="24" y="21" textAnchor="middle" fontFamily="'Bricolage Grotesque', sans-serif" fontWeight="800" fontSize="13" fill="white" letterSpacing="-0.5">
        PK
      </text>
      {/* COACH text */}
      <text x="24" y="34" textAnchor="middle" fontFamily="'DM Sans', sans-serif" fontWeight="700" fontSize="6" fill="rgba(255,255,255,0.75)" letterSpacing="2.5">
        COACH
      </text>
      <defs>
        <linearGradient id="shield-grad" x1="24" y1="2" x2="24" y2="46">
          <stop offset="0" stopColor="#e84057" />
          <stop offset="1" stopColor="#c026d3" />
        </linearGradient>
        <linearGradient id="stroke-grad" x1="24" y1="2" x2="24" y2="46">
          <stop offset="0" stopColor="#ff6b7a" />
          <stop offset="1" stopColor="#d946ef" />
        </linearGradient>
        <linearGradient id="inner-grad" x1="24" y1="5" x2="24" y2="43">
          <stop offset="0" stopColor="white" stopOpacity="0.15" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default Logo;
